import { DetectionZone, DetectionZoneCardinalDirection, getDetectionZoneCardinalDirectionDisplayName } from "@app/shared";
import { useEffect } from "react";
import { CheckboxInput, EnumSelect, Input, InputRow, NumericInput } from "../../inputs";

type DetectionZoneConfigProps = {
    currentZone: DetectionZone;
    onChange: (zone: DetectionZone) => void;
    isEditable?: boolean;
    isCollapsed: boolean;
    cantDeleteReason: string | undefined;
};

export const DetectionZoneConfig: React.FC<DetectionZoneConfigProps> = ({ currentZone, onChange, isCollapsed, isEditable = false, cantDeleteReason }) => {

    const hasDirection = (currentZone.zoneCardinalDirection !== null && currentZone.zoneCardinalDirection !== undefined) || (currentZone.zoneCardinalDirectionDegrees !== undefined && currentZone.zoneCardinalDirectionDegrees !== null);

    const handleOnChange = (key: keyof DetectionZone, value: DetectionZone[keyof DetectionZone]) => {
        const direction = key === "zoneCardinalDirection" ? value as number : currentZone.zoneCardinalDirectionDegrees;
        const newValue = new DetectionZone({ ...currentZone, zoneCardinalDirectionDegrees: direction, [key]: value });
        onChange(newValue);
    }

    const handleHasDirectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(new DetectionZone({ ...currentZone, zoneCardinalDirection: e.target.checked ? currentZone.zoneCardinalDirection : undefined, zoneCardinalDirectionDegrees: e.target.checked ? 0 : undefined }));
    };

    useEffect(() => {
        //If we have a degrees value but no cardinal direction, we need to set the cardinal direction
        if ((currentZone.zoneCardinalDirection === undefined || currentZone.zoneCardinalDirection === null) && currentZone.zoneCardinalDirectionDegrees !== undefined && currentZone.zoneCardinalDirectionDegrees !== null) {
            if (Object.values(DetectionZoneCardinalDirection).find(key => key === currentZone.zoneCardinalDirectionDegrees) === undefined) {
                onChange(new DetectionZone({ ...currentZone, zoneCardinalDirection: DetectionZoneCardinalDirection.Custom }));
            } else {
                onChange(new DetectionZone({ ...currentZone, zoneCardinalDirection: currentZone.zoneCardinalDirectionDegrees }));
            }
        }
    }, [currentZone.zoneCardinalDirection]);


    if (isCollapsed) { return null; }
    return (
        <>
            <InputRow label="Detection Zone Type">
                <Input onChange={(e) => handleOnChange("name", e.target.value)} label="Name" value={currentZone.name} disabled={!isEditable} />
            </InputRow>
            <InputRow>
                <NumericInput label="Zone Index" onChange={(e) => handleOnChange("zoneIndex", e)} value={currentZone.zoneIndex} disabled={!isEditable} />
            </InputRow>
            <InputRow>
                <CheckboxInput label="Zone has direction?" checked={hasDirection} onChange={handleHasDirectionChange} disabled={!isEditable} />
            </InputRow>
            {hasDirection &&
                <InputRow>
                    <EnumSelect enumType={DetectionZoneCardinalDirection}
                        nameToDisplayConverter={getDetectionZoneCardinalDirectionDisplayName}
                        label="Direction"
                        emptyOptionText="Select Direction"
                        onChange={(e) => handleOnChange("zoneCardinalDirection", e)}
                        value={currentZone.zoneCardinalDirection}
                        disabled={!isEditable}
                    />
                </InputRow>
            }
            {currentZone.zoneCardinalDirection === DetectionZoneCardinalDirection.Custom &&
                <InputRow>
                    <NumericInput
                        label="Custom Direction (°)"
                        onChange={(e) => handleOnChange("zoneCardinalDirectionDegrees", e)}
                        value={currentZone.zoneCardinalDirectionDegrees}
                        disabled={!isEditable} />
                </InputRow>
            }

            <p className="text-center font-medium text-sm mt-4" style={{ color: "red" }}>
                {cantDeleteReason}
            </p>
        </>
    );
}
